import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { useExtension as useExtensionQuery } from '@/api/use-extension';
import { extensionSSEAtom } from '@/store/atoms';

export const useExtension = (): {
  number: string;
  password?: string;
} | null => {
  const sseExtension = useAtomValue(extensionSSEAtom);
  const query = useExtensionQuery();

  return useMemo(() => {
    if (sseExtension) {
      return { number: sseExtension };
    }
    return query.data ?? null;
  }, [sseExtension, query.data]);
};
